import { createContext, useContext } from 'react';

// True while a container block (column grid, icon card grid) renders its
// nested blocks with their View inside the block editor.
export const EditPreviewContext = createContext(false);

export const useIsEditPreview = () => useContext(EditPreviewContext);
